module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c02"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 3300 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Bronze")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Bronze is the first metal that gets its own age, which began around 3300 BCE in Mesopotamia. Other metals were certainly in use before it—especially copper—but the addition of a small amount of tin to existing copper technology changed everything. Bronze was a step up in hardness, durability, and resistance to corrosion. Unfortunately, tin and copper ores generally aren’t found together, which meant that an area rich in one ingredient had to trade for the other. Beginning around 2000 BCE, tin from Cornwall (southwest Britain) was in such demand that it turned up in many eastern Mediterranean archaeological sites, thousands of miles away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We don’t know much about these early chemists and metallurgists, but it’s clear that they experimented with whatever they had on hand. Bronze alloys have turned up with all sorts of other metals in them—lead, arsenic, nickel, antimony, and even precious metals like silver. Those must have taken especially large amounts of nerve to add to the mix, since it was almost certain at the time that you would never see them again (the techniques to repurify such metals would not arrive for many centuries).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And thus, the long human adventure with metallurgy began—one that is nowhere near over. Bronze itself has been improved over the years—the Greeks added more lead to make the resulting alloy easier to work with, and the addition of zinc takes you into the various forms of brass. Modern bronzes often have aluminum or silicon in them, which were completely unknown to the ancients. If you want to see real, old-fashioned bronze of a kind that would have been recognized thousands of years ago, take a close look at a drum kit. Bronze has been the preferred metal for bells and cymbals for hundreds of years. The more tin in the mix, the lower the timbre, but there is no record of what adding arsenic or silver might do to the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c04"
    }
  }, [_vm._v("Iron Smelting (c. 1300 BCE)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("De Re Metallica")]), _vm._v(" (1556)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/017.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This ancient, Chinese bronze bell may have been part of a larger set, tuned and shaped to produce different notes. Casting bronze instruments to such specific tolerances is a serious technical challenge.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5db1b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c02.vue
// module id = 81
// module chunks = 0